<template>
  <main class="main page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div v-if="step === 1" class="verification-step step-1">
            <div class="title">
              <h3 class="title__text title">
                Account Verification
              </h3>
              <div class="title__desc desc">
                Verify your account to enjoy all the benefits CryptoSelling has to offer.
              </div>
            </div>
            <div class="content">
              <div class="card-list">
                <div class="card-list__item">
                  <div class="item-title title small">Verify ID</div>
                  <div class="item-desc desc">
                    Get instant verification of your ID/driver's license/passport. To make sure your application is
                    accepted, please read the requirements first.
                  </div>

                  <div class="photo-content">
                    <div class="photo-content__requirements">
                      <div class="requirements__title title small">
                        Requirements:
                      </div>
                      <ul class="requirements__list">
                        <li class="requirement desc">
                          - Allowed formats: JPG, PNG, GIF, TIFF, PDF and BMP;
                        </li>
                        <li class="requirement desc">
                          - Provide coloured high-resolution images (at least 200 dpi);
                        </li>
                        <li class="requirement desc">
                          - Documents must be up to date;
                        </li>
                        <li class="requirement desc">
                          - Documents must be between 50KB and 8MB.
                        </li>
                      </ul>
                    </div>
                    <div class="photo-content__upload" @dragover.prevent @drop="onDrop">
                      <div v-if="uploadedImages.length === 0 && serverImages.length === 0" class="upload-placeholder">
                        <img src="../images/user_document.svg" alt="" class="upload__img">
                        <div class="upload__desc desc">
                          Drag & drop your ID pictures to upload
                        </div>
                        <button class="button gray upload__btn" @click="triggerFileInput">
                          Browse
                        </button>

                        <input type="file" ref="fileInput" @change="onFileChange" accept="image/*" class="file-input"
                               style="display: none;" multiple/>
                      </div>

                      <div v-else class="uploaded-files">
                        <ul class="file-list">
                          <!-- Отображение серверных изображений -->
                          <li v-for="(image, index) in serverImages" :key="index" class="file-item">
                            <div class="file-info">
                              <img :src="image" alt="" class="file-preview">
                            </div>
                          </li>
                          <!-- Отображение загруженных изображений -->
                          <li v-for="(image, index) in uploadedImages" :key="index" class="file-item">
                            <div class="file-info">
                              <span :class="['file-name', 'desc', {uploaded: typeof image === 'string'}]" class="file-name  desc">{{ index + 1 }}. {{ typeof image === 'string' ? image.split('/').pop() : image.name }}</span>
                              <img :src="typeof image === 'string' ? `${appStaticDomain}/storage/${image}` : image.preview" alt="" class="file-preview">
                              <button class="remove-button" @click="removeFile(index)">
                                ✖
                              </button>
                            </div>
                          </li>
                        </ul>
                        <button v-if="uploadedImages.length < 2" class="button gray upload__btn"
                                @click="triggerFileInput">
                          Add another file
                        </button>

                        <input type="file" ref="fileInput" @change="onFileChange" accept="image/*" class="file-input"
                               style="display: none;" multiple/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-list__item next-step">
                  <button class="button gray">Cancel</button>
                  <button :disabled="uploadedImages.length < 1 || loading" @click="submitFirstStep" class="button">
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="step === 2" class="verification-step step-2">
            <div class="title">
              <h3 class="title__text title">
                Account Verification
              </h3>
              <div class="title__desc desc">
                Verify your account to enjoy all the benefits CryptoSelling has to offer.
              </div>
            </div>
            <div class="content">
              <form @submit.prevent="submitSecondStep" class="card-list">
                <div class="card-list__item">
                  <div class="item-title title small">Add Personal Information</div>
                  <div class="form">
                    <div class="row">
                      <label>
                        <input required type="text" placeholder="Enter first name" v-model="firstName"/>
                      </label>
                    </div>
                    <div class="row">
                      <label>
                        <input required type="text" placeholder="Enter last name" v-model="lastName"/>
                      </label>
                    </div>
                    <div class="row row_birth_date">
                      <div class="desc align-left">Date of birth:</div>
                      <label>
                        <v-select class="select"
                                  :clearable="false"
                                  :searchable="false"
                                  :options="daysInMonth"
                                  v-model="birthDay"
                                  placeholder="Day"
                        />
                        <v-select class="select"
                                  :clearable="false"
                                  :searchable="false"
                                  :options="months"
                                  v-model="birthMonth"
                                  placeholder="Month"
                        />
                        <v-select class="select"
                                  :clearable="false"
                                  :searchable="false"
                                  :options="birthYears"
                                  v-model="birthYear"
                                  placeholder="Year"
                        />
                      </label>
                    </div>
                    <div class="row row_sex">
                      <label>
                        <input v-model="sex" class="custom-radio" value="m" type="radio" name="sex">
                        <span class="row_sex__radio_title" >Male</span>
                      </label>

                      <label>
                        <input v-model="sex" class="custom-radio" value="f" type="radio" name="sex">
                        <span class="row_sex__radio_title">Female</span>
                      </label>
                    </div>
                    <div class="row">
                      <label>
                        <input required type="text" placeholder="Enter phone number" v-model="phoneNumber"/>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="card-list__item next-step">
                  <button type="button" @click="step = 1" class="button gray">Back</button>
                  <button type="submit" :disabled="!firstName || !lastName || !phoneNumber " class="button">
                    Next
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div v-else-if="step === 3" class="verification-step step-3">
            <div class="title">
              <h3 class="title__text title">
                Account Verification
              </h3>
              <div class="title__desc desc">
                Verify your account to enjoy all the benefits CryptoSelling has to offer.
              </div>
            </div>
            <div class="content">
              <form @submit.prevent="submitThirdStep" class="card-list">
                <div class="card-list__item">
                  <div class="item-title">
                    <div class="item-title__text title small">Billing Address</div>
                    <div class="item-title__desc desc">(must match your utility bill)</div>
                  </div>
                  <div class="form">
                    <div class="row">
                      <label>
                        <input required type="text" placeholder="Enter country" v-model="country"/>
                      </label>
                    </div>
                    <div class="row">
                      <label>
                        <input required type="text" placeholder="Enter city" v-model="city"/>
                        <input required type="text" placeholder="Enter ZIP code" v-model="zip"/>
                      </label>
                    </div>
                    <div class="row">
                      <label>
                        <input required type="text" placeholder="Enter address (street/apt/ets)" v-model="address"/>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="card-list__item next-step">
                  <button type="button" @click="step = 2" class="button gray">Back</button>
                  <button type="submit" :disabled="!firstName || !lastName || !phoneNumber " class="button">
                    Finish
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>

// import ExchangeButton from "@/components/ExchangeButton.vue";
// import FiatSection from "@/components/FiatSection.vue";
// import CryptoSection from "@/components/CryptoSection.vue";
import {mapActions, mapGetters} from "vuex";
import vSelect from "vue-select";

export default {
  name: 'Verification',
  props: [],
  components: {
    // CryptoSection,
    // FiatSection,
    // ExchangeButton
    vSelect
  },
  data: function () {
    return {
      appStaticDomain: process.env.VUE_APP_STATIC_DOMAIN,
      step: 1,
      uploadedImages: [], // Список загруженных изображений,
      serverImages: [], // Список изображений с сервера
      loading: false,
      firstName: '',
      lastName: '',
      birthDay: {code: 1, label: '1'},
      birthMonth: {code: 1, label: "January"},
      birthYear: {code: 2000, label: '2020'},
      sex: 'm',
      phoneNumber: '',
      country: '',
      city: '',
      zip: '',
      address: '',
      months: [
        {code: 1, label: "January"},
        {code: 2, label: "February"},
        {code: 3, label: "March"},
        {code: 4, label: "April"},
        {code: 5, label: "May"},
        {code: 6, label: "June"},
        {code: 7, label: "July"},
        {code: 8, label: "August"},
        {code: 9, label: "September"},
        {code: 10, label: "October"},
        {code: 11, label: "November"},
        {code: 12, label: "December"}
      ]
    }
  },
  watch: {},
  computed: {
    ...mapGetters('user', ['isVerified', 'profile']),
    birthYears() {
      const currentYear = new Date().getFullYear();
      const yearsRange = 100; // Сколько лет назад считать
      const years = [];

      for (let i = 0; i <= yearsRange; i++) {
        const year = currentYear - i;
        years.push({ code: year, label: String(year) });
      }

      return years;
    },
    daysInMonth() {
      if (!this.birthYear || !this.birthMonth) {
        return [];
      }

      // Получаем номер месяца и год
      const month = this.birthMonth.code; // Номер месяца (1-12)
      const year = this.birthYear.code; // Год

      // Определяем количество дней в месяце
      const days = new Date(year, month, 0).getDate(); // Последний день предыдущего месяца

      // Формируем массив дней
      return Array.from({ length: days }, (_, i) => ({
        code: i + 1,
        label: String(i + 1)
      }));
    }
  },
  methods: {
    ...mapActions('user', ['fetchProfileUnverified']),
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFileChange(event) {
      const files = Array.from(event.target.files);
      this.handleFiles(files);
    },
    onDrop(event) {
      const files = Array.from(event.dataTransfer.files);
      this.handleFiles(files);
    },
    handleFiles(files) {
      const allowedFormats = ['image/jpeg', 'image/png', 'image/gif', 'image/tiff', 'image/bmp'];
      files.forEach(file => {
        if (this.uploadedImages.length >= 2) {
          this.$toast('You can upload up to 2 files only', {type: 'error'});
          return;
        }
        if (!allowedFormats.includes(file.type)) {
          this.$toast('Unsupported file format', {type: 'error'});
          return;
        }
        if (file.size < 50000 || file.size > 8000000) {
          this.$toast('File size must be between 50KB and 8MB', {type: 'error'});
          return;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
          this.uploadedImages.push({
            name: file.name,
            file,
            preview: e.target.result
          });
        };
        reader.readAsDataURL(file);
      });
    },
    removeFile(index) {
      this.uploadedImages.splice(index, 1);
    },
    async submitFirstStep() {
      try {
        const data = new FormData();

        if (this.uploadedImages[0] && !(typeof this.uploadedImages[0] === 'string')) {
          data.append('doc_1', this.uploadedImages[0].file);
        } else if (!this.uploadedImages[0]) {
          data.append('doc_1', '');
        }

        if (this.uploadedImages[1] && !(typeof this.uploadedImages[1] === 'string')) {
          data.append('doc_2', this.uploadedImages[1].file);
        } else if (!this.uploadedImages[1]) {
          data.append('doc_2', '');
        }

        await this.$http.post(process.env.VUE_APP_API + 'user/verification/docs', data);
        await this.fetchProfileUnverified();

        if (this.profile.verification_data) {
          this.uploadedImages = [];
        }

        if (this.profile.verification_data?.document_scan1) {
          this.uploadedImages.push(this.profile.verification_data.document_scan1);
        }

        if (this.profile.verification_data?.document_scan2) {
          this.uploadedImages.push(this.profile.verification_data.document_scan2);
        }

        this.step = 2;
      } catch (error) {
        if (error.response) {
          if (error.response.status === 400) {
            const errorData = error.response.data;
            if (errorData && errorData.message) {
              this.$toast(errorData.message, {type: 'error'});
            }
          }
        } else if (error.request) {
          console.error('No response received:', error.request);
        } else {
          console.error('Error:', error.message);
        }
      }
    },
    async submitSecondStep() {
      try {
        const birthDate = `${this.birthYear.code}-${String(this.birthMonth.code).padStart(2, '0')}-${String(this.birthDay.code).padStart(2, '0')}`;

        const today = new Date();
        const birthDateObj = new Date(birthDate);
        const age = today.getFullYear() - birthDateObj.getFullYear();
        const isBirthdayPassed = today.getMonth() > birthDateObj.getMonth() ||
            (today.getMonth() === birthDateObj.getMonth() && today.getDate() >= birthDateObj.getDate());

        if (age < 18 || (age === 18 && !isBirthdayPassed)) {
          this.$toast('You must be at least 18 years old to proceed.', { type: 'error' });
          return;
        }

        await this.$http.post(process.env.VUE_APP_API + 'user/verification/personal-info', {
          first_name: this.firstName,
          last_name: this.lastName,
          sex: this.sex,
          phone: this.phoneNumber,
          birth_date: birthDate,
        });

        this.step = 3;
      } catch (error) {
        if (error.response) {
          if (error.response.status === 400) {
            const errorData = error.response.data;
            if (errorData && errorData.message) {
              this.$toast(errorData.message, { type: 'error' });
            }
          }
        } else if (error.request) {
          console.error('No response received:', error.request);
        } else {
          console.error('Error:', error.message);
        }
      }
    },
    async submitThirdStep() {
      try {
        await this.$http.post(process.env.VUE_APP_API + 'user/verification/billing-address', {
          country: this.country,
          city: this.city,
          zip: this.zip,
          address: this.address
        });

        this.$toast('Verification submitted.', { type: 'success' });
        await this.$router.push({name: 'Profile'});
      } catch (error) {
        if (error.response) {
          if (error.response.status === 400) {
            const errorData = error.response.data;
            if (errorData && errorData.message) {
              this.$toast(errorData.message, { type: 'error' });
            }
          }
        } else if (error.request) {
          console.error('No response received:', error.request);
        } else {
          console.error('Error:', error.message);
        }
      }
    }
  },
  mounted: async function () {
    await this.fetchProfileUnverified();

    if (this.profile.verification_data) {
        this.firstName = this.profile.verification_data?.first_name;
        this.lastName = this.profile.verification_data?.last_name;
        this.sex = this.profile.verification_data?.sex;
        this.phoneNumber = this.profile.verification_data?.phone;

        this.country = this.profile.verification_data?.country;
        this.city = this.profile.verification_data?.city;
        this.zip = this.profile.verification_data?.zip;
        this.address = this.profile.verification_data?.address;

      const birthDate = this.profile.verification_data?.birth_date;
      console.log(birthDate, 'birth_date');

      if (birthDate) {
        const [year, month, day] = birthDate.split('-').map(num => String(num).padStart(2, '0')).map(Number); // Добавляем padStart для двухзначного формата
        this.birthYear = this.birthYears.find(y => y.code == year); // Устанавливаем соответствующий год
        this.birthMonth = this.months.find(m => m.code == month); // Устанавливаем соответствующий месяц
        this.birthDay = this.daysInMonth.find(d => d.code == day); // Устанавливаем соответствующий

        console.log(this.birthYear, this.birthMonth, this.birthDay, 'date');
      }

      if (this.profile.verification_data.document_scan1) {
        this.uploadedImages.push(this.profile.verification_data.document_scan1);
      }

      if (this.profile.verification_data.document_scan2) {
        this.uploadedImages.push(this.profile.verification_data.document_scan2);
      }
    }
  }
}
</script>
